<template>
  <div class="amc-classroom-container">
    <div class="amc-header">
      <div class="header-left">
        <h1 class="course-title">课堂</h1>
      </div>
    </div>

    <div class="content">
      <div class="actions">
        <el-button type="primary" size="small" @click="joinByInvite">输入邀请码加入</el-button>
        <el-button size="small" @click="loadMyClasses">刷新</el-button>
        <span v-if="filterLevel" style="margin-left: 8px; color: #909399; font-size: 12px;">
          当前筛选：{{ filterLevel }}
        </span>
      </div>

      <el-skeleton v-if="loading" :rows="6" animated />

      <div v-else>
        <div v-if="classes.length === 0" class="empty">
          <div class="empty-title">{{ filterLevel ? '未加入该级别班级' : '暂无已加入的班级' }}</div>
          <!-- <div class="empty-desc">{{ filterLevel ? '请确认你已加入对应级别的会员班（例如 AMC8会员），或通过邀请码加入。' : '你可以通过邀请码加入班级后再进入课堂。' }}</div> -->

          <div v-if="!filterLevel" class="class-list" style="margin-top: 12px;">
            <div class="class-card" @click="enterDefaultAmcCourse">
              <div class="card-main">
                <div class="class-name">AMC精品课程</div>
                <div class="class-meta">
                  <span>班级ID: 5</span>
                </div>
                <div class="class-desc">默认大班</div>
              </div>
              <div class="card-arrow"><i class="el-icon-arrow-right"></i></div>
            </div>
          </div>
        </div>

        <div v-else class="class-list">
          <div
            v-for="item in classes"
            :key="String(item.classId)"
            class="class-card"
            @click="enterClass(item)"
          >
            <div class="card-main">
              <div class="class-name">{{ item.className || '未命名班级' }}</div>
              <div class="class-meta">
                <span>班级ID: {{ item.classId }}</span>
                <span v-if="item.courseId" style="margin-left: 12px;">课程ID: {{ item.courseId }}</span>
              </div>
              <div v-if="item.description" class="class-desc">{{ item.description }}</div>
            </div>
            <div class="card-arrow"><i class="el-icon-arrow-right"></i></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { myClasses, joinByInviteCode, getClassById } from '@/api/amcCourseClass'

export default {
  name: 'AmcClassroom',
  data() {
    return {
      loading: false,
      classes: [],
      filterLevel: '',
      usageLimit: 0
    }
  },
  created() {
    this.applyFilterFromRoute()
    this.loadMyClasses()
  },
  watch: {
    '$route.query.courseLevel': {
      handler() {
        this.applyFilterFromRoute()
        this.loadMyClasses()
      }
    }
  },
  methods: {
    applyFilterFromRoute() {
      const q = this.$route?.query || {}
      const lvl = String(q.courseLevel || '').trim().toUpperCase()
      this.filterLevel = lvl
      const limit = Number(q.limit)
      this.usageLimit = Number.isFinite(limit) && limit > 0 ? limit : 0
    },

    async loadMyClasses() {
      this.loading = true
      try {
        // 优先从URL获取repoId，兜底使用硬编码映射
        let repoId = this.$route?.query?.repoId ? Number(this.$route.query.repoId) : null
        if (!repoId && this.filterLevel) {
          const levelToRepo = {
            'AMC8': 14,
            'AMC10': 15,
            'AMC12': 16,
            '袋鼠数学LEVEL1': 17,
            '袋鼠数学LEVEL2': 18,
            'CCF-GESP LEVEL1': 19,
            'GESP LEVEL1': 19,
            'GESP': 19
          }
          repoId = levelToRepo[this.filterLevel]
        }

        // 传递repo_id给后端，后端会筛选出该repo_id对应的课程班级
        const res = await myClasses(repoId)
        const list = res?.data?.data ?? res?.data ?? []
        const rows = Array.isArray(list) ? list : []

        this.classes = rows
      } catch (e) {
        console.error('加载我的班级列表失败:', e)
        this.$message.error('加载班级列表失败')
      } finally {
        this.loading = false
      }
    },

    async joinByInvite() {
      const inputResult = await this.$prompt('请输入班级邀请码以加入班级', '加入班级', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^.+$/,
        inputErrorMessage: '邀请码不能为空'
      }).catch(() => null)

      if (!inputResult) return

      const inviteCode = String(inputResult.value || '').trim()
      if (!inviteCode) return

      try {
        const joinRes = await joinByInviteCode(inviteCode)
        const resCode = joinRes?.code ?? joinRes?.data?.code
        const resData = joinRes?.data?.data ?? joinRes?.data ?? {}
        const resMsg = joinRes?.msg ?? joinRes?.data?.msg

        if (resCode !== 1 || !resData.success) {
          this.$message.error(resMsg || '加入班级失败，请检查邀请码是否正确')
          return
        }

        this.$message.success('成功加入班级')
        await this.loadMyClasses()
      } catch (e) {
        console.error('加入班级失败:', e)
        this.$message.error('加入班级失败')
      }
    },

    enterClass(item) {
      const courseId = item?.courseId
      if (!courseId) {
        this.$message.error('无法获取班级对应的课程信息')
        return
      }
      const query = {}
      if (this.usageLimit > 0) query.limit = this.usageLimit
      this.$router.push({ path: `/teacher-course/${courseId}`, query })
    },

    async enterDefaultAmcCourse() {
      try {
        const memberClassId = 5
        const classRes = await getClassById(memberClassId)
        const classInfo = classRes?.data?.data ?? classRes?.data ?? null
        const courseId = classInfo?.courseId ?? classInfo?.course_id
        if (!courseId) {
          this.$message.error('无法获取课程信息')
          return
        }
        const query = {}
        if (this.usageLimit > 0) query.limit = this.usageLimit
        this.$router.push({ path: `/teacher-course/${courseId}`, query })
      } catch (e) {
        console.error('进入课程失败:', e)
        this.$message.error('进入课程失败')
      }
    }
  }
}
</script>

<style scoped>
.amc-classroom-container {
  min-height: 100vh;
  background: #f5f7fa;
}

.amc-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 18px;
  background: #fff;
  border-bottom: 1px solid #ebeef5;
}

.course-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}

.content {
  padding: 16px;
}

.actions {
  display: flex;
  gap: 10px;
  margin-bottom: 12px;
}

.empty {
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 12px;
  padding: 18px;
}

.empty-title {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 6px;
}

.empty-desc {
  font-size: 12px;
  color: #909399;
}

.class-list {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
}

.class-card {
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 12px;
  padding: 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  transition: all 0.15s ease;
}

.class-card:hover {
  border-color: #c6d1ff;
  box-shadow: 0 6px 18px rgba(102, 126, 234, 0.12);
}

.class-name {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 6px;
}

.class-meta {
  font-size: 12px;
  color: #909399;
}

.class-desc {
  margin-top: 6px;
  font-size: 12px;
  color: #606266;
  line-height: 1.4;
}

.card-arrow {
  color: #c0c4cc;
}
</style>
